import $ from 'jquery';

$('a[href*="#"]:not([href="#"]):not(.js-collapse-btn)').on('click', function() {
	let offset = window.innerWidth >= 1080 && $(document.body).hasClass('scrolled') ? -60 : 0;
	if ($(this).hasClass('plans-and-pricing-anchor')) {
		if (window.innerWidth >= 1080) {
			offset = -490;
		}
		if (window.innerWidth >= 1480) {
			offset = -430;
		}
	}

    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
        if (target.length) {
            $('html, body').animate({
                scrollTop: target.offset().top + offset
            }, 100);
            return false;
        }
    }
});